import React from "react";

const PILLARS = [
  {
    n: "01",
    title: "Built for real businesses",
    copy: "Solutions designed around how companies actually operate — not just how software looks.",
  },
  {
    n: "02",
    title: "Structured delivery",
    copy: "Clear process from discovery to launch, ensuring projects are delivered properly.",
  },
  {
    n: "03",
    title: "Designed for growth",
    copy: "Every build is created with scalability, usability and long-term value in mind.",
  },
];

export default function ValueStrip() {
  return (
    <section
      id="value"
      data-testid="value-strip-section"
      className="relative py-16 md:py-20 border-y border-white/[0.06] bg-[#06101D]/60"
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px rounded-2xl overflow-hidden border border-white/10 bg-white/[0.02]">
          {PILLARS.map((p, i) => (
            <div
              key={p.n}
              data-testid={`value-pillar-${i}`}
              className="mk-reveal bg-[#07111F] px-7 py-9 md:px-10 md:py-12"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="font-mono text-[11px] tracking-widest text-[#00D4FF]">
                {p.n}
              </div>
              <h3 className="mt-4 font-display text-2xl md:text-[26px] text-white tracking-tight leading-tight">
                {p.title}
              </h3>
              <p className="mt-3 text-[14.5px] text-slate-400 leading-relaxed max-w-sm">
                {p.copy}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
